

















































import {
    Vue,
    Component,
} from 'vue-property-decorator';
import API from '@/Api';
@Component
export default class Survey extends Vue {
    public dialog: boolean = false;
    public isSubmitted: any = null;
    public data: any = [];
    public question: any = [];
    public radioGroup: any = null;

    public mounted() {
        this.getData();
    }

    public getData() {
        API.Instance
            .get('/api/covid')
            .then((res) => {
                this.dialog = res.data;
            });
    }
    public getQuestionAndAnswer() {
        API.Instance
            .get('/api/survey/getQuestion')
            .then((respone) => {
                this.question = respone.data;
            });
    }
    public post() {
        
        API.Instance
            .post(`api/covid`)
            .then((res) => {
                this.getData();
            });
    }
}
